import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';

@Injectable()
export class EquipmentService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }
  public postComplianceInspection(complianceDTO): Promise<any> {
    return new Promise((resolve, reject) => {
      if (window.location.hostname === 'localhost') {
        console.log("postComplianceInspection: ", "dev");
        this.http.post<any>('api/equipment/postComplianceInspection', complianceDTO).subscribe(data => {
          resolve(data);
        }, error => {
          ////console.log(error);
          reject(error);
        });
      } else {
        console.log("postComplianceInspection: ", "live");

        this.http.post<any>(environment.apiUrl + 'api/equipment/postComplianceInspection', complianceDTO).subscribe(data => {
          resolve(data);
        }, error => {
          ////console.log(error);
          reject(error);
        });
      }
    });
  }


  public getByQR(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      if (window.location.hostname === 'localhost') {
        console.log("postComplianceInspection: ", "dev");

        this.http.get<any>('api/equipment/getByQR?QR=' + id).subscribe(data => {
          resolve(data);
        }, error => {
          ////console.log(error);
          reject(error);
        });

      } else {
        console.log("postComplianceInspection: ", "live");

        this.http.get<any>(environment.apiUrl + 'api/equipment/getByQR?QR=' + id).subscribe(data => {
          resolve(data);
        }, error => {
          ////console.log(error);
          reject(error);
        });
      }

    });
  }



}
